import { PaintedScene, type PaintedSceneInitData } from './PaintedScene';
import type { PaintedSceneAssetSpec } from './sceneAssetSpec.schema';
import type { JourneyManifest } from './journeyManifest.schema';

export const FOREST_HOLLOW_SCENE_PHASER_KEY = 'ForestHollowScene' as const;
export const FOREST_HOLLOW_SCENE_MANIFEST_KEY = 'scene-3-forest-hollow' as const;

export class ForestHollowScene extends PaintedScene {
  constructor() {
    super(FOREST_HOLLOW_SCENE_PHASER_KEY, FOREST_HOLLOW_SCENE_MANIFEST_KEY);
  }

  protected provideAssetSpec(): PaintedSceneAssetSpec | null {
    return null;
  }

  protected provideManifest(): JourneyManifest | null {
    return null;
  }

  init(data?: PaintedSceneInitData): void {
    super.init(data);
  }
}
